<template>
  <div class="ls-theme-cyanogen container subscribe-wrapper">
    <header class="main-header ls-md-margin-top">
      <h1 class="trade-name" >{{ basicSeller.trade_name || basicSeller.name }}</h1>
      <h3 class="subtitle">{{ $t('payments.messages.finalize_payment') }}</h3>
    </header>
    <flash-message class="container ls-sm-margin-top"></flash-message>
    <choose-payment class="checkout-details col-md-12"  v-if="choosePayment && invoiceIsValid"></choose-payment>
    <card v-if="card"></card>
    <transfer v-if="transfer"></transfer>
    <checkout-yapay v-if="checkoutYapay"></checkout-yapay>
    <p v-if="!choosePayment && canChangePayment" class="ls-text-sm ls-md-space ls-no-padding ls-md-margin-top"><a href="javascript:void(0)" @click="changePaymentMethod">{{ $t('payments.messages.change_method') }}</a></p>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import * as location from 'src/utils/location'
  import ChoosePayment from './ChoosePayment.vue'
  import Billet from './Billet.vue'
  import Card from './Card.vue'
  import Transfer from './Transfer.vue'
  import TransferDone from './TransferDone.vue'
  import LoginYapay from './LoginYapay.vue'
  import CheckoutYapay from './CheckoutYapay.vue'
  import InvoiceDetails from './components/InvoiceDetails.vue'
  import money from 'src/utils/money'
  import date from 'src/utils/date'
  export default {
    props: ['message'],
    components: { ChoosePayment, Billet, Card, Transfer, TransferDone, LoginYapay, CheckoutYapay, InvoiceDetails },
    data () {
      return {
        date: date,
        money: money,
        choosePayment: true,
        card: false,
        transfer: false,
        loginYapay: false,
        checkoutYapay: false,
        choosePlan: true,
        canChangePayment: true,
        invoiceIsValid: true
      }
    },
    methods: {
      ...mapActions(['loadSellerData', 'loadInvoiceById', 'pay']),
      ...mapMutations(['clearFlash', 'addFlash']),
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      loadBillet () {
        this.clearFlash()
        this.$loader.show()
        var self = this
        this.pay({ id: this.invoice_id, method: 'billet' })
          .then(function (response) {
            self.afterCreateBillet(response)
          })
      },
      afterCreateBillet (response) {
        if (response.status === 200) {
          this.$router.push('/payment/invoice/' + this.invoice.id + '/billet/success')
          this.choosePayment = false
        }
        this.$loader.hide()
      },
      loadCard () {
        this.clearFlash()
        this.$loader.show()
        this.card = true
        this.choosePayment = false
      },
      loadCardDone () {
        this.clearFlash()
        this.$loader.show()
        this.$router.push('/payment/invoice/' + this.invoice.id + '/card/success')
        this.choosePayment = false
        setTimeout(this.$loader.hide, 700)
      },
      loadTransfer () {
        this.clearFlash()
        this.$loader.show()
        this.transfer = true
        this.choosePayment = false
        setTimeout(this.$loader.hide, 700)
      },
      loadTransferDone () {
        this.clearFlash()
        this.$loader.show()
        this.transfer = false
        this.choosePayment = false
        this.$router.push('/payment/invoice/' + this.invoice.id + '/transfer/success')
        setTimeout(this.$loader.hide, 700)
      },
      loadLoginYapay () {
        this.clearFlash()
        this.loginYapay = true
        this.choosePayment = false
        window.location.href = (process.env.URL_PORTAL + '/payment/invoice/' + this.invoice.id + '/yapay/signin/' + window.location.host.split('.')[0])
      },
      loadCheckoutYapay () {
        this.clearFlash()
        this.checkoutYapay = true
        this.loginYapay = false
      },
      loadCheckoutYapayDone () {
        this.clearFlash()
        this.$loader.show()
        this.$router.push('/payment/invoice/' + this.invoice.id + '/balance/success')
        this.choosePayment = false
        setTimeout(this.$loader.hide, 700)
      },
      returnToCheckoutYapay () {
        this.clearFlash()
        this.$loader.show()
        this.checkoutYapay = false
        this.loginYapay = true
        setTimeout(this.$loader.hide, 700)
      },
      changePaymentMethod () {
        this.$loader.show()
        this.clearFlash()
        this.card = false
        this.transfer = false
        this.loginYapay = false
        this.checkoutYapay = false
        this.choosePayment = true
        setTimeout(this.$loader.hide, 700)
      },
      checkInvoiceCanceled () {
        if (this.invoice.status === 'canceled') {
          this.choosePayment = false
          this.canChangePayment = false
          this.addFlash({ message: this.$t('payments.messages.invoice_canceled'), type: 'ls-alert-danger' })
        }
      },
      checkInvoiceRefunded () {
        if (this.invoice.status === 'refunded') {
          this.choosePayment = false
          this.canChangePayment = false
          this.addFlash({ message: this.$t('payments.messages.invoice_refunded'), type: 'ls-alert-danger' })
        }
      },
      checkInvoicePaid () {
        if (this.invoice.status === 'paid') {
          this.choosePayment = false
          this.canChangePayment = false
          this.clearFlash()
          this.addFlash({ message: this.$t('payments.messages.invoice_paid'), type: 'ls-alert-success' })
        }
      },
      checkInvoiceAwaitingApproval () {
        if (this.invoice.status === 'awaiting_approval') {
          this.choosePayment = false
          this.canChangePayment = false
          this.clearFlash()
          this.addFlash({ message: this.$t('payments.messages.invoice_awaiting_approval'), type: 'ls-alert-success' })
        }
      },
      checkInvoicePartiallyPaid () {
        if (this.invoice.status === 'partially_paid') {
          this.choosePayment = false
          this.canChangePayment = false
          this.clearFlash()
          this.addFlash({ message: this.$t('payments.messages.invoice_partially_paid'), type: 'ls-alert-success' })
        }
      },
      checkInvoiceValid (response) {
        if (response.status === 404) {
          this.invoiceIsValid = false
          this.addFlash({ message: this.$t('payments.messages.invalid_invoice'), type: 'ls-alert-danger' })
        }
        this.$loader.hide()
      }
    },
    created () {
    },
    computed: {
      ...mapGetters(['basicSeller', 'invoice']),
      invoice_id () {
        return this.$route.params.id
      }
    },
    mounted () {
      this.$loader.show()

      this.loadInvoiceById({ invoice_id: this.invoice_id }).then(this.checkInvoiceValid)
      this.loadSellerData(this.getUsernameFromUrl()).then(this.afterloadSellerData)

      this.$watch('invoice', function (newVal, oldVal) {
        this.checkInvoiceCanceled()
        this.checkInvoiceRefunded()
        this.checkInvoicePaid()
        this.checkInvoiceAwaitingApproval()
        this.checkInvoicePartiallyPaid()
      })
      this.$watch('choosePlan', function (newVal, oldVal) {
        this.clearFlash()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Main.vue?90a9bb9a